<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <div class="container">
      <vgtree ref="xTree" class="vgtree" :list="list" tableheight="700" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick">
              <template slot="btn">
                  <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
              </template>
      </vgtree>
      <el-form :model="form" ref="form"  class="content ss-fl" v-if="menuform">
        <el-form-item label="序号" :label-width="formLabelWidth">
          <el-input v-model="form.menuseq" :maxlength="4" auto-complete="off" ></el-input>
        </el-form-item>
        <el-form-item label="上级" :label-width="formLabelWidth">
          <el-select v-model="form.menuparentid" :clearable="true" >
            <el-option v-for="(item, index) in menuList" :label="item.menuname" :value="item.menuid" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.menuname" :maxlength="60" show-word-limit auto-complete="off" ></el-input>
        </el-form-item>
        <el-form-item label="路由" :label-width="formLabelWidth">
          <el-input v-model="form.menucode" :maxlength="40" show-word-limit ></el-input>
        </el-form-item>
        <el-form-item label="路由地址" :label-width="formLabelWidth">
          <el-input v-model="form.menuurl" :maxlength="255" show-word-limit ></el-input>
        </el-form-item>
        <el-form-item label="菜单图标" :label-width="formLabelWidth">
          <el-input v-model="form.menuicon" :maxlength="255" show-word-limit ></el-input>
        </el-form-item>
        <!-- <el-form-item label="" :label-width="formLabelWidth">
          <el-button type="primary" @click="saveMenu">保存</el-button>
          <el-button type="primary" @click="sortMenuBtn">重新排序</el-button>
          <el-button type="danger" @click="delMenu">删除</el-button>
        </el-form-item> -->
        <el-row>
            <vggrid ref="xGrid" class="vggrid" :list="menubtns" tableheight="300" flexname="" :cols="btncols"
                    :showfooter="false" :showPage="false" :resizable="true"
                    :needBlackRow="false" :needPopMenu="false" :canbeEdit="true"
            >
              <template slot="btn">
                  <vxe-button icon="el-icon-check" status="perfect" @click="saveMenu">保存</vxe-button>
                  <vxe-button icon="el-icon-s-operation" status="perfect"  @click="sortMenuBtn">重新排序</vxe-button>
                  <vxe-button icon="el-icon-delete" status="perfect"  @click="delMenu">删除</vxe-button>
              </template>
            </vggrid>
        </el-row>
      </el-form>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vgtree from '../common/vgtree1'
  import vggrid from '../common/vggrid'
  import MenuBtn from "../common/menuBtn"
  export default {
    name: 'menuIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        menuform: false,
        menubtns:[],
        menuList: [],
        btncols: [
          { type: 'checkbox',fieldtype: 'I', title: '选择',calculExpr:'', width: 80},
          { field: 'menubtnseq',fieldtype: 'I', title: '顺序号',calculExpr:'', width: 80,editRender: { name: 'input'}},
          { field: 'btnname', fieldtype: 'C', title: '名称', width: 100,calculExpr:''},
          { field: 'menubtnposition', fieldtype: 'C', title: '按钮显示位置',syscode: 'menubtnposition', calculExpr:'',editRender: { name: 'select', options: []}},
        ],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80},
          { field: 'menuname', fieldtype: 'C', title: '名称',calculExpr:''}
        ],
        query: {
          total: 0,
          currPage: 1,
          pageSize: 20
        },
        menu: {},
        form: {},
        loading: true,
        formLabelWidth: '100px'
      }
    },
    activated() {
      this.getMenuTree()
      this.getMenuFolderList()
    },
    created () {
      this.$on('ADD', () => this.addMenu())
      this.$on('SAV', () => this.saveMenu())
      this.$on('DEL', () => this.delMenu())
      this.$on('SORT', () => this.sortMenu())
      this.$on('FIELD', () => this.rfieldForm())
      this.$on('CLOSE', () => this.close())
    },
    mounted () {
    },
    watch: {
      $route() {
      }
    },
    components: {MenuBtn,vgtree,vggrid},
    methods: {
      initform() {
        this.menubtns = []
        this.btncols = [
          { type: 'checkbox',fieldtype: 'I', title: '选择',calculExpr:'', width: 80},
          { field: 'menubtnseq',fieldtype: 'I', title: '顺序号',calculExpr:'', width: 80,editRender: { name: 'input'}},
          { field: 'btnname', fieldtype: 'C', title: '名称',width: 80,calculExpr:''},
          { field: 'menubtnposition', fieldtype: 'C', title: '按钮位置',syscode: 'menubtnposition', calculExpr:'',editRender: { name: 'select', options: []}},
        ]
        this.menu = {}
        this.form = {}
      },
      btnClick (code) {
        this.$emit(code)
      },
      async rfieldForm () {
        if (!this.menu.menuid) {
          this.$message.warning('请选择一行!')
          return
        }
        this.$router.push({name: 'rfieldForm', params: {form: this.menu}})
      },
      async addMenu () {
        this.initform()
        let maxSeq = 0
        this.list.forEach(item => {
          if (item.menuseq>maxSeq) {
            maxSeq = item.menuseq
          }
        })
        maxSeq += 10
        this.form = {
          menuid: 0,
          menuseq: maxSeq,
          menucode: '',
          menuname: '',
          menuurl: ''
        }
        this.menuform = true
      },
      async getMenuFolderList() {
        this.menuList = await request({
          url: '/kfgl/menu/getMenuFolderList',
          method: "get",
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
        this.menuList.splice(0,0,{
          menuname: '无',
          menuid: 0
        })
      },
      async sortMenuBtn () {
        let model ={
          menuid: this.form.menuid,
          menubtns: this.$refs.xGrid.$refs.xGrid.getSelectRecords()
        }
        let data = await request({
          url: '/kfgl/menu/sortMenuBtn',
          method: "post",
          data: model
        })
        if (data.issuccess === 1) {
          this.getMenubtnList()
          this.$message.success('排序成功！')
        } else {
          this.$message.error('排序失败！')
        }
      },
      async delMenu () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/menu/delMenu',
            method: "post",
            data: this.form
          })
          console.log(data)
          if (data.issuccess === 1) {
            this.getMenuTree()
            this.$message.success('删除成功！')
          }
        })
      },
      async saveMenu () {
        this.form.insertRecords = this.$refs.xGrid.$refs.xGrid.getSelectRecords()
        await request({
          url: '/kfgl/menu/saveMenu',
          method: "post",
          data: this.form
        })
        this.$message.success('操作成功')
        await this.getMenuTree()
        //this.menuform = false
      },
      async cellClick (row) {
        this.initform()
        this.menu = row.row
        this.form = row.row
        this.getMenubtnList()
        this.menuform = true
      },
      async getMenubtnList() {
        console.log(this.menu)
          this.menubtns = await request({
            url: '/kfgl/menu/getMenuBtnList',
            method: "get",
            params: {menuid: this.menu.menuid}
          })
      },
      async getMenuTree () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/menu/getMenuTree',
          params: {}
        })
        this.list = res.list
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    .vgtree {
      border: 1px solid #d1dbe5;
      width: 400px;
      margin-right: 5px;
    }
    .vggrid {
      margin-left: 50px;
      width: 800px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
</style>
